import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

import { SearchInput, Select } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  spacingLeft: {
    marginLeft: theme.spacing(1)
  },
  spacingRight: {
    marginRight: theme.spacing(1)
  }
}));

const ProductsToolbar = props => {
  const { className, onSearch, brands, search, brand, handleChange, ...rest } = props;

  const classes = useStyles();
  const [value, setValue] = useState('')

  const handleKeyUp = ev => {
    if (ev.key === 'Enter') {
      handleChange(ev)
    }
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Link to="/import">
          <Button className={classes.spacingRight}>导入</Button>
        </Link>
        <Button className={classes.spacingRight}>导出</Button>
        <Link to="/products/new">
          <Button
            color="primary"
            variant="contained"
          >
            新增产品
          </Button>
        </Link>
      </div>
      <div className={classes.row}>
        <Select
          options={brands}
          name="brand"
          defaultValue="请选择品牌"
          value={brand}
          onChange={handleChange}
        />
        <SearchInput
          className={clsx(classes.spacingLeft, classes.spacingRight)}
          placeholder="Search product"
          name="search"
          value={value}
          onChange={ev => setValue(ev.target.value)}
          onKeyUp={handleKeyUp}
        />
      </div>
    </div>
  );
};

ProductsToolbar.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func
};

export default ProductsToolbar;
